import { render, staticRenderFns } from "./ProjectDetails.vue?vue&type=template&id=ce865976"
import script from "./ProjectDetails.vue?vue&type=script&lang=ts"
export * from "./ProjectDetails.vue?vue&type=script&lang=ts"
import style0 from "./ProjectDetails.vue?vue&type=style&index=0&id=ce865976&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports